var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c("div", { staticClass: "address-list-container col-3" }, [
      _c(
        "div",
        { staticClass: "address-box clearfix" },
        [
          _c(
            "el-checkbox-group",
            {
              model: {
                value: _vm.selectRegionIds,
                callback: function($$v) {
                  _vm.selectRegionIds = $$v
                },
                expression: "selectRegionIds"
              }
            },
            [
              _c(
                "ul",
                { staticClass: "address-list" },
                _vm._l(_vm.provinces, function(item) {
                  return _c(
                    "li",
                    { staticClass: "address-item" },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { label: item.id },
                          on: {
                            change: function($event) {
                              _vm.checkChange(item, 2)
                            }
                          }
                        },
                        [_vm._v(" ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "inline-block city-name",
                          on: {
                            click: function($event) {
                              _vm.regionChange(item, 2)
                            }
                          }
                        },
                        [_vm._v(_vm._s(item.name))]
                      )
                    ],
                    1
                  )
                })
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "el-checkbox-group",
            {
              model: {
                value: _vm.selectRegionIds,
                callback: function($$v) {
                  _vm.selectRegionIds = $$v
                },
                expression: "selectRegionIds"
              }
            },
            [
              _c(
                "ul",
                { staticClass: "address-list" },
                _vm._l(_vm.citys, function(item) {
                  return _c(
                    "li",
                    { staticClass: "address-item" },
                    [
                      _vm.selectRegionIds.indexOf(item.provinceId) < 0
                        ? _c(
                            "el-checkbox",
                            {
                              attrs: {
                                label: item.id,
                                disabled:
                                  _vm.selectRegionIds.indexOf(
                                    item.provinceId
                                  ) >= 0
                              },
                              on: {
                                change: function($event) {
                                  _vm.checkChange(item, 3)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                             \n                        "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "inline-block city-name",
                          on: {
                            click: function($event) {
                              _vm.regionChange(item, 3)
                            }
                          }
                        },
                        [_vm._v(_vm._s(item.name))]
                      )
                    ],
                    1
                  )
                })
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "el-checkbox-group",
            {
              model: {
                value: _vm.selectRegionIds,
                callback: function($$v) {
                  _vm.selectRegionIds = $$v
                },
                expression: "selectRegionIds"
              }
            },
            [
              _c(
                "ul",
                { staticClass: "address-list" },
                _vm._l(_vm.countys, function(item) {
                  return _c(
                    "li",
                    { staticClass: "address-item" },
                    [
                      _vm.selectRegionIds.indexOf(item.provinceId) < 0 &&
                      _vm.selectRegionIds.indexOf(item.cityId) < 0
                        ? _c(
                            "el-checkbox",
                            {
                              attrs: {
                                label: item.id,
                                disabled:
                                  _vm.selectRegionIds.indexOf(item.cityId) >=
                                    0 ||
                                  _vm.selectRegionIds.indexOf(
                                    item.provinceId
                                  ) >= 0
                              },
                              on: {
                                change: function($event) {
                                  _vm.checkChange(item, 4)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                             \n                        "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "inline-block city-name",
                          on: {
                            click: function($event) {
                              _vm.regionChange(item, 4)
                            }
                          }
                        },
                        [_vm._v(_vm._s(item.name))]
                      )
                    ],
                    1
                  )
                })
              )
            ]
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _vm.isShowDiv
      ? _c(
          "div",
          { staticClass: "simple-row" },
          [
            _c("span", [_vm._v("当前选择：")]),
            _vm._l(_vm.selectRegionList, function(item) {
              return _c("span", { staticClass: "ml15" }, [
                _vm._v(_vm._s(item.regionName))
              ])
            })
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-888c5726", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-888c5726","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/comn/RegionSelect.vue
// module id = 2388
// module chunks = 0